<template>
  <div class="mt-auto bg-slate pb-6 pt-8 md:pb-8 md:pt-10 lg:pt-16">
    <div class="container">
      <div class="mb-3 flex flex-col md:justify-between lg:flex-row">
        <div
          class="mb-12 mt-[3.625rem] block h-[1px] w-full bg-gray opacity-20 md:my-10 lg:hidden"
        ></div>

        <FooterMainMenu :menu="menuFooter"></FooterMainMenu>

        <div class="order-first lg:order-last lg:ml-auto">
          <SocialsList :items="socialNetworks" dark />
        </div>
      </div>

      <div
        class="my-12 h-[1px] w-full bg-gray opacity-20 md:my-10 lg:my-12"
      ></div>

      <div class="flex flex-col justify-between align-middle md:flex-row">
        <FooterBottomMenu :menu="menuBottom"></FooterBottomMenu>

        <div v-if="isJoinuApp" class="mr-auto text-sm text-gray md:order-first">
          If you have any questions please contact us:
          <a href="mailto:support@joinu.app" class="text-white hover:underline">
            support@joinu.app
          </a>
          <br />
          © {{ new Date().getFullYear() }} Prestigio Solutions
        </div>
        <div v-else class="mr-auto text-sm text-gray md:order-first">
          © {{ new Date().getFullYear() }} Prestigio Solutions
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FooterMainMenu from '@/domains/menus/components/FooterMainMenu.vue';
import FooterBottomMenu from '@/domains/menus/components/FooterBottomMenu.vue';
import SocialsList from '@/components/SocialsList.vue';
import { useSocials } from '~/composables';

interface Props {
  menuFooter?: any[];
  menuBottom?: any[];
}

withDefaults(defineProps<Props>(), {
  menuFooter: () => [],
  menuBottom: () => [],
});
const { joinuApp: isJoinuApp } = useRuntimeConfig().public.frontkit;
const { socials: socialNetworks } = useSocials();
</script>
